export const SET_HORSE = "SET_HORSE"

export const setHorse = (horse) => ({
  type: SET_HORSE,
  payload: horse 
})


